import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledFlex = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
